import { getLineItemTaxRate } from "@secureo/common/utils/tax"

import { LockingSystemProduct } from "@secureo/common/typings/LockingSystem"
import { CountryCode } from "@secureo/common/typings/CountryCode"

const getTaxRateFromDefaultLockingComponent = (
	defaultLockingComponent: LockingSystemProduct,
	countryCode: CountryCode,
) => {
	const { initialCylinderConfigurationVariant, variants } = defaultLockingComponent

	const { shippingOriginationCountryCodesByDestinationCountryCode } =
		initialCylinderConfigurationVariant?.masterVariant?.attributes ??
		variants?.[0]?.attributes ??
		{}

	const shippingOriginationCountryCode =
		shippingOriginationCountryCodesByDestinationCountryCode?.[countryCode] ?? "DE"

	const { taxRate } = getLineItemTaxRate(shippingOriginationCountryCode, countryCode)

	return taxRate
}

export default getTaxRateFromDefaultLockingComponent
